import Reveal from '@/components/base/Reveal';
import { SETUP_STEPS, useSetupFlow } from '@/pages/mt5-setup/SetupFlowContext';

function SetupOverview() {
  const { active, goToStep } = useSetupFlow();

  return (
    <section className="w-full border-y border-background-200 bg-background-100 px-4 md:px-8 lg:px-12 py-12 md:py-16">
      <div className="max-w-[1440px] mx-auto grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] gap-6 lg:gap-16 items-center">
        <Reveal>
          <div className="flex items-center gap-3 mb-5">
            <span className="text-[11px] font-data tracking-[0.24em] text-primary-600">
              THE PROCESS
            </span>
            <span className="w-8 h-px bg-primary-400"></span>
          </div>
          <h2 className="font-heading font-extrabold tracking-tight text-[28px] leading-[1.1] sm:text-[38px] lg:text-[44px]">
            <button
              type="button"
              onClick={() => goToStep(1)}
              aria-label="Go to Step 01: Install"
              className="group cursor-pointer text-left inline-flex flex-wrap items-baseline gap-x-2 text-foreground-950"
            >
              {SETUP_STEPS.map((step, idx) => (
                <span
                  key={step.index}
                  className={`transition-colors duration-500 ${
                    active === idx + 1
                      ? 'text-primary-600'
                      : 'text-foreground-950 group-hover:text-foreground-700'
                  }`}
                >
                  {step.title}.
                </span>
              ))}
              <i
                className="ri-arrow-right-line text-[0.5em] text-foreground-300 transition-all duration-300 group-hover:translate-x-1 group-hover:text-primary-500"
                aria-hidden="true"
              ></i>
            </button>
          </h2>
        </Reveal>

        <Reveal delay={100}>
          <p className="text-[15px] leading-relaxed text-foreground-600 max-w-[620px] lg:max-w-none">
            The setup follows the standard MetaTrader 5 workflow. Each step below is broken down
            into the individual actions you perform inside the terminal.
          </p>
        </Reveal>
      </div>
    </section>
  );
}

export default SetupOverview;